module.exports = __webpack_public_path__ + "static/media/price-icon102.674cc59b.png";